import { PollForm } from './PollForm';

export default function PollPage() {
  return (
    <div className="w-full max-w-5xl mx-auto px-0 md:px-4 py-0 md:py-6">
      <PollForm />
    </div>
  );
}
